export default __webpack_public_path__ + "static/media/Lined_Paper_Background_For_Site.e30d6f7e.png";